import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { AlertCustomSerasaDialog } from "src/app/shared/components/alert-custom-serasa-dialog/alert-custom-serasa-dialog.component";
import { AlertCustomSerasaEnum } from "src/app/core/enum/alert-custom-serasa.enum";
import { ApiServiceSerasa } from "src/app/core/services/serasa.service";
import { NgxSpinnerService } from "ngx-spinner";
import { PDF } from "../../classes/pdf";

@Component({
  selector: "dialog-confirm-extract",
  templateUrl: "./dialog-confirm-extract.component.html",
  styleUrls: ["./dialog-confirm-extract.component.scss"]
})
export class DialogConfirmExtractComponent extends PDF implements OnInit {
  @Input() titleText: string;
  @Input() titleColor: string;
  @Input() text: string;
  @Input() confirmButtonText: string;
  @Input() cancelButtonText: string;
  @Output() callbackConfirm = new EventEmitter<string>();

  @Input("data") data;
  @Output() errorData = new EventEmitter();

  ngOnInit(): void {}

  constructor(
    private apiServiceSerasa: ApiServiceSerasa,
    public dialogRef: MatDialogRef<DialogConfirmExtractComponent>,
    private matDialog: MatDialog,
    private spinner: NgxSpinnerService
  ) {
    super();
  }

  confirm() {
    this.callbackConfirm.emit();
    this.dialogRef.close();
  }

  close() {
    this.dialogRef.close();
  }

  openSuccessDialog(): void {
    const modal = this.matDialog.open(AlertCustomSerasaDialog, {
      width: "600px",
      panelClass: "alert-custom"
    });

    modal.componentInstance.icon = AlertCustomSerasaEnum.SUCCESS;
    modal.componentInstance.title = "CONSULTA REALIZADA COM SUCESSO";
    modal.componentInstance.message = "A consulta foi encaminhada para o e-mail cadastrado.";
    modal.componentInstance.buttonText = "Confirmar";
    modal.componentInstance.buttonTheme = AlertCustomSerasaEnum.SUCCESS;
  }

  openErrorDialog(): void {
    const modal = this.matDialog.open(AlertCustomSerasaDialog, {
      width: "600px",
      panelClass: "alert-custom"
    });

    modal.componentInstance.icon = AlertCustomSerasaEnum.ERROR;
    modal.componentInstance.title = "OCORREU UM ERRO AO FAZER A CONSULTA";
    modal.componentInstance.message = "Verifique se o CPF/CNPJ é um documento válido";
    modal.componentInstance.buttonText = "Entendi";
    modal.componentInstance.buttonTheme = AlertCustomSerasaEnum.ERROR;
  }

  openExistDialog(config): void {
    const modal = this.matDialog.open(AlertCustomSerasaDialog, {
      width: "600px",
      panelClass: "alert-custom"
    });

    modal.componentInstance.icon = AlertCustomSerasaEnum.ERROR;
    modal.componentInstance.title = config.message;
    modal.componentInstance.message = config.description;
    modal.componentInstance.buttonText = "Entendi";
    modal.componentInstance.buttonTheme = AlertCustomSerasaEnum.ERROR;
  }

  createConsult(): void {
    this.spinner.show();

    this.data.cnpj_customer = this.data.cnpj_customer.replace(/[^\w\s]/gi, "");

    this.apiServiceSerasa.createConsult(this.data).subscribe({
      next: res => {
        this.downloadPDF(res.archive);
        this.openSuccessDialog();
        this.dialogRef.close();
      },
      error: error => {
        this.spinner.hide();

        if (error.message === "Saldo insuficiente") {
          this.dialogRef.close();
          return this.openExistDialog({ message: error.message, description: "Adicione saldo para consultar" });
        }

        if (
          error.message === "CNPJ ou CPF já cadastrado para outro cliente" ||
          error.message === "Já cadastrado em outro cliente"
        ) {
          this.errorData.emit({
            error:
              "Infelizmente você não pode realizar essa consulta, pois esse documento se encontra cadastrado na base de outro cliente"
          });
        }

        this.dialogRef.close();
        this.openErrorDialog();
      },
      complete: () => {
        this.spinner.hide();
      }
    });
  }
}
